const initialState = {
	tehsilesOfDistrict: {
		data: null,
		loading: false,
		error: null,
	}
};

const tehsilesReducer = (state = initialState, { type, error, payload, data }) => {
	switch (type) {
		case "GET_TEHSILES_OF_DISTRICT_SUCCESS":
			return {
				...state,
				tehsilesOfDistrict: {
					...state.tehsilesOfDistrict,
					loading: false,
					data: data,
				},
			};
		case "GET_TEHSILES_OF_DISTRICT_FAIL":
			return {
				...state,
				tehsilesOfDistrict: {
					...state.tehsilesOfDistrict,
					loading: false,
					error,
				},
			};
		default:
		return state;
	}
};

export default tehsilesReducer;
